import { render, staticRenderFns } from "./themColor.vue?vue&type=template&id=4dee8fed&"
import script from "./themColor.vue?vue&type=script&lang=js&"
export * from "./themColor.vue?vue&type=script&lang=js&"
import style0 from "./themColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports